import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ForwardCaseDialogComponent } from '../forward-case-dialog/forward-case-dialog.component';

interface ReturnCaseData {
   title: string;
}

@Component({
   selector: 'app-return-case-reason-dialog',
   templateUrl: './return-case-reason-dialog.component.html',
   styleUrls: ['./return-case-reason-dialog.component.scss'],
})
export class ReturnCaseReasonDialogComponent {
   returnReasonForm: FormGroup;
   title: string;

   constructor(
      private formBuilder: FormBuilder,
      public dialogRef: MatDialogRef<ForwardCaseDialogComponent>,
      @Optional() @Inject(MAT_DIALOG_DATA) public returnCase: ReturnCaseData
   ) {}

   ngOnInit(): void {
      this.returnReasonForm = this.formBuilder.group({
         returnReason: ['', [Validators.required]],
      });

      this.title = this.returnCase.title;
   }

   returnCaseWithReason(submittedForm: FormGroup) {
      const returnReasonMessage = submittedForm.get('returnReason').value;
      this.dialogRef.close({ event: 'SUCCESS', data: returnReasonMessage });
   }

   closeDialog() {
      this.dialogRef.close({ event: 'Cancel' });
   }
}
